import React from 'react';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import HR from '@zg-rentals/multibrand-ui/lib/HR';
import './index.scss';

class Or extends React.Component {
  render() {
    return (
      <Row className="or-component">
        <Col>
          <HR />
        </Col>
      </Row>
    );
  }
}

export default Or;
